import React, {FC, ReactElement, useMemo } from 'react';
import styles from './index.less'
import cfg from 'config';

const Footer: FC = () : ReactElement=> {

  const showIcp = useMemo(()=>{
    return cfg.showIcp
  }, [])

  return (
    <div className={styles.footer}>
      {
        showIcp &&
        <div className={styles.icp}>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备2022042981号-1</a>
        </div>
      }
    </div>
  )
}

export default Footer